module.exports = __webpack_public_path__ + "img/LogoTransparent.10341f1e.svg";